// eslint-disable-next-line no-restricted-imports
import { Provider as ReduxStoreProvider } from "react-redux";

import { toastLocalizedOperationCatcher, toastSuccessMessage } from "../../../../utils/alerts";

import { serverImportSection } from "api/api-server-actions";
import { ImportSectionModal } from "components/materials/section/content/ImportSectionModal";
import { ImportSectionRequestType } from "components/server-types";
import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { showConfirmationModal } from "mds/components/Modal";
import { CopySendArrowIcon } from "mds/icons";
import { store } from "store/index";

const onShowModal = async (onSave: (data: ImportSectionRequestType) => void) => {
  const data = (await showConfirmationModal({
    title: t("import_modal.import_section"),
    hideCancelConfirmButtons: true,
    children: (onClose: () => void, onConfirm: (data) => void) => (
      <ReduxStoreProvider store={store}>
        <ImportSectionModal onCancel={onClose} onConfirm={onConfirm} />
      </ReduxStoreProvider>
    ),
  })) as ImportSectionRequestType;
  if (data) {
    return onSave(data);
  }
};

export const ImportSectionButton = () => {
  const handleImport = (data: ImportSectionRequestType) => {
    serverImportSection(data)
      .then(() => {
        toastSuccessMessage(t("success.toasts.import_section_started_success"));
      })
      .catch(toastLocalizedOperationCatcher("import_section_failure"));
  };

  return (
    <Button
      className="gap-2"
      kind="blue"
      size="s"
      title={t("content_view.import_section")}
      onClick={() => {
        onShowModal(handleImport).catch(toastLocalizedOperationCatcher("import_modal_failure"));
      }}
    >
      <CopySendArrowIcon />
      {t("content_view.import_section")}
    </Button>
  );
};
